import { FOCUS_AREAS, type FocusArea } from "@/lib/focusAreas";
import type { Timeframe } from "@/hooks/useTrendTopics";
import { cn } from "@/lib/utils";

const TIMEFRAMES: { value: Timeframe; label: string }[] = [
  { value: "24h", label: "24h" },
  { value: "7d", label: "7 days" },
  { value: "30d", label: "30 days" },
];

export default function TrendFilters({
  focus,
  onFocusChange,
  timeframe,
  onTimeframeChange,
}: {
  focus: FocusArea | "all";
  onFocusChange: (f: FocusArea | "all") => void;
  timeframe: Timeframe;
  onTimeframeChange: (t: Timeframe) => void;
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onFocusChange("all")}
          className={cn(
            "px-3 py-1.5 rounded-full text-xs font-medium border transition-colors",
            focus === "all"
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-card text-muted-foreground border-border hover:border-primary/40",
          )}
        >
          All
        </button>
        {FOCUS_AREAS.map((fa) => {
          const isHealth = fa === "Health & Wellness";
          const active = focus === fa;
          return (
            <button
              key={fa}
              type="button"
              onClick={() => onFocusChange(fa)}
              className={cn(
                "px-3 py-1.5 rounded-full text-xs font-medium border transition-colors",
                active && isHealth && "bg-pink-500 text-white border-pink-500",
                active && !isHealth && "bg-primary text-primary-foreground border-primary",
                !active && "bg-card text-muted-foreground border-border hover:border-primary/40",
              )}
            >
              {fa}
            </button>
          );
        })}
      </div>
      <div className="inline-flex rounded-full border border-border bg-card p-1">
        {TIMEFRAMES.map((t) => (
          <button
            key={t.value}
            type="button"
            onClick={() => onTimeframeChange(t.value)}
            className={cn(
              "px-3 py-1 rounded-full text-xs font-medium transition-colors",
              timeframe === t.value
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {t.label}
          </button>
        ))}
      </div>
    </div>
  );
}